import React, { useEffect, useReducer, useState, useMemo } from "react"
import { get } from "lodash"

import { ForeignTemplate } from "components/templates/top/foreign"
import {
  requestPriceListAPIs,
  usePriceList,
} from "components/actions/priceList"
import { APIResponse } from "redux/apis/types"
import { withRouter, WithRouterProps } from "react-router"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useLodingTrigger, LoadingTriger } from "components/actions/loading"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"
import { TrustTemplate } from "../../../templates/domestic"

const initialPriceListState = {
  name: "Top.FX.JPY",
}

export const Foreign: WithRouterProps<React.FC> = withRouter(({ location }) => {
  const { loading, setLoading } = useLodingTrigger()
  const [priceListState, usePriceListReducer] = useReducer(
    usePriceList,
    initialPriceListState
  )
  const [currencyData, setCurrencyData] = useState<APIResponse.Res>({})
  const [totalCount, setTotalCount] = useState()
  const [refreshFlag, setRefreshFlag] = useState(false)
  const loadResistId = useMemo(() => uuid(), [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  useEffect(() => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    requestPriceListAPIs(priceListState).then((data: APIResponse.Res) => {
      setCurrencyData(data)
      setTotalCount(get(data, "TotalCount"))
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }, [priceListState])

  useEffect(() => {
    if (!loading) return
    setLoading(false)
    store.dispatch(pageLoadRegist(loadResistId, true))
    requestPriceListAPIs(priceListState).then((data: APIResponse.Res) => {
      setCurrencyData(data)
      setTotalCount(get(data, "TotalCount"))
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }, [loading])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) {
      store.dispatch(pageLoadRegist(loadResistId, true))
      requestPriceListAPIs(priceListState).then((data: APIResponse.Res) => {
        setCurrencyData(data)
        setTotalCount(get(data, "TotalCount"))
        store.dispatch(pageLoadRegist(loadResistId, false))
      })
    }
  }, [isPageLoading])

  useEffect(() => {
    if (refreshFlag) {
      store.dispatch(pageLoadRegist(loadResistId, true))
      requestPriceListAPIs(priceListState).then((data: APIResponse.Res) => {
        setCurrencyData(data)
        setTotalCount(get(data, "TotalCount"))
        store.dispatch(pageLoadRegist(loadResistId, false))
      })
      setRefreshFlag(false)
    }
  }, [refreshFlag])

  return (
    <LoadingTriger.Provider value={{ loading, setLoading }}>
      <ForeignTemplate
        currencyList={currencyData}
        currencyListState={priceListState}
        currencyListAction={usePriceListReducer}
        totalCount={totalCount}
        transitionData={get(location.state, "rowData")}
        setRefreshFlag={setRefreshFlag}
      />
    </LoadingTriger.Provider>
  )
})
